import { toast } from "react-hot-toast";
import { useAsyncStateSupabaseCallback } from "../../../utils/hooks/use-async-state-callback";
import { SupabaseProgramService } from "../../programs/server/supabase-program-service";

import type { UUID } from "../../../utils/uuid";
import type { Program } from "../../programs/server/supabase-program-service";

/** What the program drawer sets: the title, the icon and the colour. */
export type ProgramLook = Pick<Program, "title" | "theme_icon" | "theme_colour">;

/**
 * Saves a program's title, icon or colour, and says if it failed. Resolves to whether it was saved.
 * Only an admin can change a program.
 */
export function useUpdateProgram(): {
  save: (id: UUID, look: Partial<ProgramLook>) => Promise<boolean | undefined>;
  saving: boolean;
} {
  const { load: save, loading: saving } = useAsyncStateSupabaseCallback(
    async ({ supabase }, id: UUID, look: Partial<ProgramLook>): Promise<boolean> => {
      const { data, error } = await new SupabaseProgramService(supabase).update(id, look);

      if (error || !data) {
        toast.error(
          error?.code === "23505"
            ? "Something there has that name already. Choose another name."
            : "Something went wrong saving the program. Please try again.",
        );
        return false;
      }

      return true;
    },
    [],
  );

  return { save, saving };
}
